(function ($) {
	"use strict";

	$(function () {
		const builders = document.querySelectorAll('.js-builder');
		const activeClass = "is-active";
		const animationClass = "is-visible";
		const slideDuration = 400;
		const accordionMq = window.matchMedia('(max-width: 1023px)');

		builders.forEach(builder => {
			const $triggers = $('.js-builder-trigger', $(builder));
			const $bodies = $('.js-builder-body', $(builder));

			$triggers.on("click", function () {
				const $trigger = $(this);
				const loopNumber = $(this).data('loop-no');
				const uuid = $(this).data('uuid');
				const $bodyToOpen = $(`#builder-body-${uuid}-${loopNumber}`);
				const $triggersToOpen = $triggers.filter(function () {
					return $(this).data('loop-no') === loopNumber;
				});

				$bodies.each(function () {
					const highlightColor = $(this).data('highlight-color');

					if ($(this).hasClass(activeClass)) {
						if (accordionMq.matches) {
							$(this)
								.stop()
								.slideUp(slideDuration, function () {
									$(this).removeClass(activeClass);
									$(this).removeClass(animationClass);
									$(this).removeAttr('style');
									$(this).css('--highlight-color', highlightColor);

									$([document.documentElement, document.body]).animate(
										{
											scrollTop: $trigger.offset().top - 80,
										},
										1000
									);
								});
						} else {
							$(this).removeClass(activeClass);
							$(this).removeClass(animationClass);
						}
					}
				});

				$triggers.each(function () {
					if ($(this).hasClass(activeClass)) {
						$(this).attr("aria-expanded", false);
						$(this).removeClass(activeClass);
					}
				});

				if (accordionMq.matches) {
					$bodyToOpen.stop().slideDown(slideDuration, function () {
						$(this).addClass(activeClass);

						setTimeout(() => {
							$(this).addClass(animationClass);
						}, 100);
					});
				} else {
					$bodyToOpen.addClass(activeClass);

					setTimeout(() => {
						$bodyToOpen.addClass(animationClass);
					}, 100);
				}

				$triggersToOpen.attr("aria-expanded", true).addClass(activeClass);
			});

			accordionMq.addEventListener("change", function () {
				if (!accordionMq.matches) {
					$bodies.removeAttr("style");

					$bodies.each(function () {
						const highlightColor = $(this).data('highlight-color');

						$(this).css('--highlight-color', highlightColor);
					});
				}
			});

			$bodies.first().addClass('is-visible');
		});
	});
})(jQuery);
